import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';

import { FormSubmitButtonUiComponent } from './form-submit-button-ui/form-submit-button-ui.component';

@NgModule({
  imports: [CommonModule, IonicModule, TranslocoModule],
  declarations: [FormSubmitButtonUiComponent],
  exports: [FormSubmitButtonUiComponent],
})
export class SharedFormUiSubmitButtonModule {}
